import React from "react"
import Slider from "react-slick"
import { Link, StaticQuery, graphql } from "gatsby"

const LastPosts = ({ lastPosts }) => {
  const blogSlider = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 750,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <Slider {...blogSlider}>
      {lastPosts.edges.map(({ node }, index) => (
        <div key={index}>
          <Link to={`/blog/${node.slug}`} className="home-blog__tile">
            <div
              className="home-blog__tile-thumb"
              style={{
                backgroundImage: `url(${
                  node.featuredImage ? node.featuredImage.node.sourceUrl : ""
                })`,
              }}
            ></div>
            <h4>{node.title}</h4>
          </Link>
        </div>
      ))}
    </Slider>
  )
}

export default () => (
  <StaticQuery
    query={graphql`
      {
        lastPosts: allWpPost(limit: 5) {
          edges {
            node {
              id
              title
              slug
              excerpt
              featuredImage {
                node {
                  id
                  sourceUrl
                }
              }
            }
          }
        }
      }
    `}
    render={data => <LastPosts {...data} />}
  />
)
